<template>
<div>

  <div style="margin-left: 70px">
    <el-button v-if="this.parentData" type="success" @click="deleteChartData">{{"数据修复"}}</el-button>
    <el-button type="primary">{{"物件选择"}}</el-button>
    <el-select v-model="wuJianId" @change="renderAllEcharts" clearable placeholder="物件名称" class="wujian_select_size">
      <el-option
          v-for="item in wuJianNames"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>

  <div class="pageContainer">

    <div class="asideContainer" style="border-right: 8px solid whitesmoke;">

      <div class="size">
        <div class="title">
          <span>{{'再手配数量'}}</span>
          <div class="space-between">
            <el-date-picker v-model="zspNum.year" @change="getNumChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="zspNum.month" @change="getNumChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <el-select v-model="zspNum.xianbie" @change="getNumChart" clearable placeholder="线别" size="small" style="width: 85px;margin-right: 10px">
              <el-option
                  v-for="item in lineType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="zspNum.bad_process" @change="getNumChart" clearable placeholder="工序" size="small" style="width: 85px">
              <el-option
                  v-for="item in process"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="chart_size" v-loading="numChartLoading" element-loading-text="数据加载中" id="ZaiShouPeiNum"/>
      </div>

    </div>

    <div class="asideContainer" >

      <div class="size">
        <div class="title">
          {{'再手配重量'}}
          <div class="space-between">
            <el-date-picker v-model="zspWei.year" @change="getWeiChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="zspWei.month" @change="getWeiChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <el-select v-model="zspWei.xianbie" @change="getWeiChart" clearable placeholder="线别" size="small" style="width: 85px;margin-right: 10px">
              <el-option
                  v-for="item in lineType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="zspWei.bad_process" @change="getWeiChart" clearable placeholder="工序" size="small" style="width: 85px">
              <el-option
                  v-for="item in process"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="chart_size" v-loading="weiChartLoading" element-loading-text="数据加载中" id="ZSPWei"/>
      </div>

    </div>

  </div>

  <KfDialog v-model="dialogVisible" :item="dialogItem">

    <template #footer>
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
        <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
          <span style="font-size: 24px;">{{this.chartData.name}}</span>
          <el-input-number v-model="this.chartData.value"/>
        </div>
        <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
      </div>
    </template>
  </KfDialog>

</div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ZaiShouPeiPage",
  props: ['parentData'],
  data(){
    return{
      dialogVisible:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      wuJianId:'',
      wuJianNames:[],
      zspNum:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        xianbie:'',
        bad_process: '',
        field:'count(*)'
      },
      zspWei:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        xianbie:'',
        bad_process: '',
        field:'sum(weight)'
      },
      lineType:[],
      process:[],
      /*物件别不良推移*/
      optionWuJian: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '再手配数量',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '再手配数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      wuJianChartLoading:false,
      /*数量不良推移*/
      optionNum: {
        type:'zaishoupai_chart_num',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '再手配数量',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '再手配数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
        ]
      },
      numChartLoading:false,
      /*重量不良推移*/
      optionWei: {
        type:'zaishoupai_chart_wei',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '再手配重量',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '再手配重量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
        ]
      },
      weiChartLoading:false,
    }
  },
  methods:{
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this
        if (this.parentData) {
          chart.on('click', function (params) {
            _this.dialogVisible = true
            _this.dialogItem.title = params.seriesName
            _this.chartData.seriesName = params.seriesName
            _this.chartData.value = params.value
            _this.chartData.name = params.name
            _this.chartData.dataIndex = params.dataIndex
            _this.chartData.seriesIndex = params.seriesIndex
            _this.chartData.chartType = option.type
          })
        }

      }
    },

    renderAllEcharts(){
      /*this.getWuJianChart()*/
      this.getNumChart()
      this.getWeiChart()
    },

    async deleteChartData(){
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_zaishoupai_page");
      if (res.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "zaishoupai_chart_num":
          this.zspNum.wujian_id = this.wuJianId
          this.zspNum.field1 = this.zspWei.xianbie
          this.zspNum.field2 = this.zspWei.bad_process
          this.chartData.query = this.zspNum
          break
        case "zaishoupai_chart_wei":
          this.zspWei.wujian_id = this.wuJianId
          this.zspWei.field1 = this.zspWei.xianbie
          this.zspWei.field2 = this.zspWei.bad_process
          this.chartData.query = this.zspWei
          break
      }
      this.chartData.model = "bus_zaishoupai_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "zaishoupai_chart_num":
          await this.getNumChart()
          break
        case "zaishoupai_chart_wei":
          await this.getWeiChart()
          break
      }

    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getProcessDict() {
      let {data: res} = await this.$axios.post('bus/datasource/getAllData','bus_zaishoupei_record.bad_process');
      if (res.code !== 0) {
        this.$message.error('获取【不良工序】失败')
        return;
      }
      this.process = res.data;
    },

    async getLineTypeDict() {
      let {data: res} = await this.$axios.post('bus/datasource/getAllData','bus_zaishoupei_record.xianbie');
      if (res.code !== 0) {
        this.$message.error('获取【不良工序】失败')
        return;
      }
      this.lineType = res.data;
    },

    /*async getWuJianChart() {
      this.wuJianChartLoading = true

      let data = {
        wujian_id:this.wuJianId
      }
      let {data: res} = await this.$axios.post('bus/zaiShouPei/ZSPChart',data);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
        this.optionWuJian.series[0].data = null
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.badNum
        }
      }
      this.renderEcharts('wuJianZaiShouPei',this.optionWuJian)

      this.wuJianChartLoading = false
    },*/

    async getNumChart() {
      this.numChartLoading = true
      if (!this.zspNum.year){
        this.zspNum.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.zspNum.chart_type = "zaishoupai_chart_num"
      this.zspNum.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zaiShouPei/ZSPChart',this.zspNum);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        if (res.data.XDay) {
          this.optionNum.xAxis[0].data = res.data.XDay
          this.optionNum.series[0].data = res.data.series
          let a = this.$common.getDivisor(Math.max(...res.data.series))
          this.optionNum.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
          this.optionNum.yAxis[0].interval = Math.round(this.optionNum.yAxis[0].max/5*100)/100
        }
      }
      this.renderEcharts('ZaiShouPeiNum',this.optionNum)

      this.numChartLoading = false
    },

    async getWeiChart() {
      this.weiChartLoading = true
      if (!this.zspWei.year){
        this.zspWei.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.zspWei.chart_type = "zaishoupai_chart_wei"
      this.zspWei.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zaiShouPei/ZSPChart',this.zspWei);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        if (res.data.XDay) {
          this.optionWei.xAxis[0].data = res.data.XDay
          this.optionWei.series[0].data = res.data.series
          let a = this.$common.getDivisor(Math.max(...res.data.series))
          this.optionWei.yAxis[0].max = Math.ceil(Math.max(...res.data.series)/a)*a
          this.optionWei.yAxis[0].interval = Math.round(this.optionWei.yAxis[0].max/5*100)/100
        }
      }
      this.renderEcharts('ZSPWei',this.optionWei)

      this.weiChartLoading = false
    },
  },

  created() {
    this.getWuJianInFo()
    this.getProcessDict()
    this.getLineTypeDict()
  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  justify-content: space-around;
  width: 100%;
}
.size{
  width: 100%;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title{
  width: 500px;
  border-left: 3px solid steelblue;
  height: 25px;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}
.chart_size{
  width: 630px;
  height: 300px
}

.asideContainer {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
</style>